import { render, staticRenderFns } from "./BulkReviewRow.vue?vue&type=template&id=07dd4801"
import script from "./BulkReviewRow.vue?vue&type=script&lang=js"
export * from "./BulkReviewRow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports